import React from 'react';
import { Box, Typography } from '@mui/material';
import { INPUT_STYLES, FIELD_WRAPPER_STYLES } from '../../theme/constants';

/**
 * FormField - A wrapper for form inputs with label above
 * 
 * Usage:
 * <FormField label="Inbound Connector" required>
 *   <Select value={connector} onChange={handleChange} fullWidth />
 * </FormField>
 */
const FormField = ({
  label,
  required = false,
  helperText,
  error = false,
  fullWidth = true,
  width,
  children,
  sx = {},
}) => {
  const wrapperStyles = width 
    ? FIELD_WRAPPER_STYLES.fieldFixed(width)
    : fullWidth 
      ? FIELD_WRAPPER_STYLES.field
      : {};

  return (
    <Box sx={{ ...wrapperStyles, ...sx }}>
      {label && (
        <Typography component="label" sx={INPUT_STYLES.inputLabel}>
          {label}
          {required && (
            <Typography component="span" sx={INPUT_STYLES.requiredMark}>*</Typography>
          )}
        </Typography>
      )}
      {children}
      {helperText && (
        <Typography 
          sx={{ 
            fontSize: '0.75rem', 
            color: error ? 'error.main' : 'text.secondary',
            mt: 0.5,
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default FormField;
